import React, { useEffect, useRef } from 'react';

const Search = ({
    locations,
    companies,
    resetTabMembers,
    tab,
    handleSearch,
    searchText,
    setSearchText,
    searchCompany,
    setSearchCompany,
    searchLocation,
    setSearchLocation,
    resetSearchOnTabChange,
    setResetSearchOnTabChange
  }) => {
  const searchBtn = useRef(null);

  const populateDropdown = (list, searchFunc) => (
    list?.map((item, idx) => (
      <li key={item + idx}>
        <a
          className="dropdown-item border-bottom"
          onClick={(e) => searchFunc(e)}
        >
          {item}
        </a>
      </li>
    ))
  );

  const resetSearches = () => {
    setSearchText('');
    setSearchCompany('');
    setSearchLocation('');
    resetTabMembers();
  };

  useEffect(() => {
    if (resetSearchOnTabChange) {
      resetSearches();
      setResetSearchOnTabChange(false);
    }
  }, [resetSearchOnTabChange]);

  const handleTextSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleCompanySearch = (e) => {
    setSearchCompany(e.target.text);
    setTimeout(() => searchBtn.current.focus(), 0);
  };

  const handleLocationSearch = (e) => {
    setSearchLocation(e.target.text);
    setTimeout(() => searchBtn.current.focus(), 0);
  };

  const handleKeyEnter= (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const styleDropdown = (search) => {
    const [unselected, selected] = ['#ABBCD5', '#3d898b'];
    return search ? { color: selected, borderColor: selected } : { color: unselected, borderColor: unselected };
  };

  return (
    <>
      <div className="row member-search mb-4">
        <form action="" className="col-12">
          <div className="input-group mb-3 flex-nowrap">
            <span className="input-group-text" id="basic-addon1">
              <i className="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              className="form-control fs-6 p-3 rounded-3 w-100"
              type="search"
              placeholder={`Search ${tab} community members`}
              aria-label="Search"
              onChange={(e) => handleTextSearch(e)}
              onKeyDown={handleKeyEnter}
              value={searchText}
            />
          </div>
        </form>
    </div>
    <div className="d-flex dropdown-menus justify-content-between mb-4">
      {tab !== 'invited' && (
        <div className="col-lg-7 col-sm-10 d-flex">
            <div className="col-md-3 dropdown">
              <button
                className="btn btn-light-gray-hover btn-outline-white btn-sm dropdown-toggle fs-6"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                data-bs-offset="-140,-10"
                style={styleDropdown(searchLocation)}
              >
                {searchLocation || 'Locations'}
              </button>
              <ul className="dropdown-menu location-dropdown py-0">
                {populateDropdown(locations, handleLocationSearch)}
              </ul>
            </div>
            <div className="col-md-10 col-lg-6 dropdown ms-2 ms-md-0">
              <button
                className="btn btn-light-gray-hover btn-outline-white btn-sm dropdown-toggle fs-6"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                data-bs-offset="20,-10"
                style={styleDropdown(searchCompany)}
              >
                {searchCompany || 'Companies'}
              </button>
              <ul className="dropdown-menu company-dropdown py-0">
                {populateDropdown(companies, handleCompanySearch)}
              </ul>
            </div>
        </div>
      )}
      {(searchText || searchCompany || searchLocation) &&
        <>
          <button
            className="btn btn-light-gray-hover btn-outline-white btn-sm fs-6 col-md-2"
            onClick={() => resetSearches()}
          >
            Reset
          </button>
          <button
          className="btn btn-light-gray-hover btn-outline-white btn-sm fs-6 col-md-2"
          onClick={handleSearch}
          ref={searchBtn}
        >
          Search
        </button>
        </>
      }
    </div>
  </>
  );
};

export default Search;
